require('style!css!sass!./materialize-styles!./materialize.config.js');



//////////////////
// WEBPACK FOOTER
// ./~/materialize-loader/index.js
// module id = 3
// module chunks = 0